import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem, Collapse } from 'react-bootstrap';
import ShopSubCategoryList  from './ShopSubCategoryList';
import NewSubCategoryForm from './NewSubCategoryForm';

class ShopCategoryList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         categoryOpen: -1
      };
      this.changeOpenCategory = this.changeOpenCategory.bind(this);
   }

   changeOpenCategory(categoryIndex) {
      this.setState({
         categoryOpen: (categoryIndex === this.state.categoryOpen) ? -1 : categoryIndex
      });
   }

   render() {
      const { categories, shopId, createNewSubCategory } = this.props;
      const { categoryOpen } = this.state;
      return (
         <ListGroup>
            {categories.map((category, categoryIndex) => (
               <ListGroupItem key={category.id} >
                  <span onClick={() => this.changeOpenCategory(categoryIndex)} >{category.name}</span>
                  <Collapse in={categoryOpen === categoryIndex} >
                     <div>
                        {category.subCategories
                        && <ShopSubCategoryList
                           subCategories={category.subCategories} />}

                        {categoryOpen === categoryIndex
                        && <NewSubCategoryForm
                           categoryId={category.id}
                           shopId={shopId}
                           createNewSubCategory={createNewSubCategory} />}
                     </div>
                  </Collapse>
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopCategoryList.propTypes = {
   categories: PropTypes.array.isRequired,
   shopId: PropTypes.number.isRequired,
   // categoryId: PropTypes.number.isRequired,
   createNewSubCategory: PropTypes.func.isRequired
};

export default ShopCategoryList;



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/ShopCategoryList.js
 **/